import { cache } from './cache';
import { link } from './link';
import { createApolloClient } from '@upheal/shared/utils/apollo/createApolloClient';

export const client = createApolloClient({
    cache,
    link,
});
